<template>
  <div>
    <el-button
        type="info"
        style="background-color: #008a2c"
        icon="el-icon-back"
        circle
        @click="goBack"
    ></el-button>
    <div
        style="
          width: 100%;
          text-align: center;
          font-size: 25px;
          font-weight: bold;
        "
    >档案查询预约
    </div>
    <div style="justify-content: center">
      <div
          style="
            margin-top: 30px;
            justify-content: center;
            margin-left: 5%;
            margin-right: 5%;
          "
      >
        <el-row justify="center" align="middle" style>
          <el-col :span="2">
            <div class="trcol">预约人</div>
          </el-col>
          <el-col :span="6">
            <div class="tdcol">{{ userInfo.amusername }}</div>
          </el-col>
          <el-col :span="2">
            <div class="trcol">学号/工号</div>
          </el-col>
          <el-col :span="6">
            <div class="tdcol">{{ userInfo.amuserid }}</div>
          </el-col>
          <el-col :span="2">
            <div class="trcol">院系/部门</div>
          </el-col>
          <el-col :span="6">
            <div class="tdcol">{{ userInfo.amuserdepartname }}</div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="2">
            <div class="trcol">专业</div>
          </el-col>
          <el-col :span="6">
            <div class="tdcol">{{ userInfo.amusermajor != null ? userInfo.amusermajor : " " }}</div>
          </el-col>
          <el-col :span="2">
            <div class="trcol">班级</div>
          </el-col>
          <el-col :span="6">
            <div class="tdcol">{{ userInfo.amuserclass != null ? userInfo.amuserclass : " " }}</div>
          </el-col>
          <el-col :span="2">
            <div class="trcol">手机号码</div>
          </el-col>
          <el-col :span="6">
            <div class="tdcol">{{ userInfo.amusertel }}</div>
          </el-col>
        </el-row>
      </div>
      <div class="form">
        <el-form ref="form" :model="form" :rules="rules" label-width="130px" v-loading="loading">
          <el-row>
            <el-col :span="24">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="联系电话：" prop="telephone">
                    <el-input v-model="form.telephone"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="电子邮箱：" prop="mail">
                    <el-input v-model="form.mail"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="24">
              <el-form-item label="预约事项：" prop="appointmentMatters">
                <el-select
                    v-model="form.appointmentMatters"
                    clearable
                    filterable
                    placeholder="请选择预约事项"
                    style="width: 100%"
                    @change="changeDept"
                >
                  <el-option
                      v-for="item in depart"
                      :key="item.value"
                      :label="item.lable"
                      :value="item.label"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="申请事由：" prop="reasonForApplication">
                <el-input
                    type="textarea"
                    :rows="2"
                    placeholder="请输入具体申请事由"
                    v-model="form.reasonForApplication"
                    :autosize="{ minRows: 4, maxRows: 6 }"
                    maxlength="100"
                    show-word-limit
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item style="align-items: center; text-align: center">
                <el-button class="submitClass" @click="onSubmit('form')">提交</el-button>
                <el-button class="colseClass" @click="goBack">取消</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
// import moment from 'moment'
// import {Message} from "element-ui";
import {addArchiveQueryAppointment} from "@/api/archiveQueryAppointment.js";
//
import {sendMsg} from "@/api/serviceInfo.js";
import {
  queryMatter,
  queryRunById,
} from "@/api/matter.js";
import moment from "moment";

export default {
  name: "archiveQuery",
  data() {
    //校验手机号
    const validatePhone = (rule, value, callback) => {
      const regExp = /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/;
      if (!regExp.test(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };
    //校验邮箱
    const validateEmile = (rule, value, callback) => {
      const regExp = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
      if (!regExp.test(value)) {
        callback(new Error("请输入正确的邮箱"));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      disabled: false,
      recepuseriddisabled: true,
      depart: [
        {
          value: 1,
          label: '档案查询'
        },{
          value: 2,
          label: '校友成绩单查询'
        }
      ],
      userInfo: {
        amuserid: "",
        amusername: "",
        amusertel: "",
        amuserdepartcode: "",
        amuserdepartname: "",
        amusermajor: "",
        amusergrade: "",
        amuserclass: ""
      },
      form: {
        // id: "",
        telephone: "",
        mail: "",
        appointmentMatters: "",
        reasonForApplication: "",
        handlestate: 1
      },
      rules: {
        telephone: [
          {required: true, validator: validatePhone, trigger: "blur"}
        ],
        mail: [
          {required: true, validator: validateEmile, trigger: "blur"}
        ],
        appointmentMatters: [
          {required: true, message: "请选择预约事项", trigger: "blur"}
        ],
        reasonForApplication: [
          {required: true, message: "请输入申请事由", trigger: "blur"}
        ],
      },
      centerArr: [],
    };
  },
  mounted() {
    let user = JSON.parse(sessionStorage.getItem("userInfo"));
    console.log('user',user);
    this.userInfo = {
      amuserid: user.userid,
      amusername: user.name,
      amusertel: user.mobile,
      amuserdepartcode: "",
      amuserdepartname: user.department,
      amusermajor: user.major,
      amusergrade: user.grade,
      amuserclass: user.bj
    };
    console.log('this.userInfo:',this.userInfo);
    this.form.telephone = this.userInfo.amusertel?this.userInfo.amusertel:''
    if(this.userInfo.amuserclass){
      this.form.appointmentMatters = '校友成绩单查询'
    }else {
      this.form.appointmentMatters = '档案查询'
      this.depart=[
        {
          value: 1,
          label: '档案查询'
        }
      ]
    }

  },
  methods: {
    //选择预约事项
    async changeDept() {
      console.log(this.form.appointmentMatters);
      this.recepuseriddisabled = false;
    },
    onSubmit(form) {
      var that = this;
      this.$refs[form].validate(async valid => {
        if (valid) {
          let applicationtime = new Date();
          var formdata = {
            ...this.form,
            reservationId:this.userInfo.amuserid,
            reservationName:this.userInfo.amusername,
            applicationtime
          };
          console.log("formdata===", formdata);
          this.loading = true;
          const data = await addArchiveQueryAppointment(formdata);
          //const data = "";
          console.log(data);
          if (data.msgCode == 0) {
            let params = {
              id: data.data.id + '-2', //事项id
              receiveUser: data.data.reservationId, //接收者userId
              memo:
                  "您在" +
                  moment(data.data.createtime).format("YYYY年MM月DD日HH点mm分") +
                  "申请了【档案查询预约】，系统正在办理中，请耐心等待！", //消息内容
              sendUser: data.data.reservationId, //发送者userId
              serviceId: "1710822985290194946", //服务id
              f4: '档案查询预约'
            };
            console.log(params);
            sendMsg(params).then((res) => {
              console.log(res);
            });
            await queryRunById(data.data.f1).then((res1) => {
              console.log('res1',res1)
              queryMatter(res1.data.f4).then((res2) => {
                if (res2.code == 0) {
                  let params1 = {
                    id: data.data.id + '-1', //事项id
                    receiveUser: res2.data[0].assigneeUser.id, //接收者userId
                    memo: "您收到一个【档案查询预约】的待处理事项，请及时处理！", //消息内容
                    sendUser: data.data.reservationId, //发送者userId
                    serviceId: "1710822985290194946", //服务id
                    f4: '档案查询预约'
                  };
                  console.log(params);
                  sendMsg(params1).then((res) => {
                    console.log(res);
                  });
                }
              });
            });
            this.$confirm(
                "您的预约已成功提交，我们会尽快受理您的预约，请及时查询微信消息通知关注预约处理进度，如有其他疑问请拨打该咨询电话：027-88143053",
                "系统提示",
                {
                  confirmButtonText: "返回主页",
                  cancelButtonText: "继续预约",
                  type: "success",
                  center: true,
                  showClose: false,
                  callback: (action, instance) => {
                    this.loading = false;
                    console.log(action);
                    console.log(instance);
                    // 返回主页
                    if (action == "confirm") {
                      that.$router.push("/serviceHome");
                    }
                    // 继续反馈
                    if (action == "cancel") {
                      this.centerArr = [];
                      this.$refs["form"].resetFields();
                    }
                  },
                  closeOnClickModal: false,
                  closeOnPressEscape: false,
                  cancelButtonClass: "cancelButtonClass",
                  confirmButtonClass: "confirmButtonClass"
                }
            )
                .then(() => {
                  that.from = {
                    id: "",
                    telephone: "",
                    mail: "",
                    appointmentMatters: "",
                    reasonForApplication: "",
                    handlestate: 1
                  };
                  console.log(that.form);

                })
                .catch(() => {
                });
          }
        }
      });
    },
    goBack() {
      this.$router.back();
    }
  }
};
</script>

<style scoped>
.trcol {
  background-color: #d8efbf;
  border: 1px solid #a0cc97;
  height: 40px;
  text-align: center;
  line-height: 40px;
}

.tdcol {
  border: 1px solid #a0cc97;
  height: 40px;
  text-align: center;
  line-height: 40px;
}

.form {
  margin-left: 5%;
  border: 1px solid #dddddd;
  margin-top: 30px;
  padding: 20px;
  margin-right: 5%;
}

.avatar-uploader-icon {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  width: 88px;
  height: 88px;
  line-height: 88px;
  text-align: center;
  margin-right: 10px;
}

.avatar {
  width: 100px;
  height: 88px;
  float: left;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  margin-right: 10px;
  line-height: 88px;
  text-align: center;
  /* display: block;  */
}

.close {
  position: absolute;
  right: 0;
  font-size: 20px;
}

.el-message-box__title {
  padding-left: 0;
  margin-bottom: 0;
  font-size: 18px;
  line-height: 1;
  color: white;
}

.el-message-box__header {
  position: relative;
  padding: 15px 15px 10px;
  background-color: #008a2c;
}

.el-message-box {
  border: 2px solid #008a2c;
  display: inline-block;
  width: 420px;
  padding-bottom: 10px;
  vertical-align: middle;
  background-color: #fff;
  border-radius: 4px;
  font-size: 18px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  text-align: left;
  overflow: hidden;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

.el-message-box--center .el-message-box__header {
  padding-top: 15px;
}

.colseClass {
  color: black;
  background-color: #bbbbbb;
  border-color: #bbbbbb;
}

.colseClass:hover,
.colseClass:focus {
  /* padding: 9px 15px; */
  background: #d9d9d9;
  border-color: #d9d9d9;
  color: black;
}

.submitClass,
.submitClass:focus {
  background-color: #008a2c;
  border-color: #008a2c;
  color: #fff;
}

.submitClass:hover {
  background: #85ce61;
  border-color: #85ce61;
  color: #fff;
}

.cancelButtonClass {
  padding: 9px 15px;
  font-size: 12px;
  background-color: #008a2c;
  border-color: #008a2c;
  color: #fff;
}

.cancelButtonClass:hover {
  padding: 9px 15px;
  font-size: 12px;
  background: #85ce61;
  border-color: #85ce61;
  color: #fff;
}

.confirmButtonClass,
.confirmButtonClass:focus {
  padding: 9px 15px;
  font-size: 12px;
  color: black;
  background-color: #bbbbbb;
  border-color: #bbbbbb;
}

.confirmButtonClass:hover {
  padding: 9px 15px;
  font-size: 12px;
  background: #d9d9d9;
  border-color: #d9d9d9;
  color: black;
}
</style>